import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import { MASTERSPECIALITES } from '../../../../graphql/query';
import Switch from '@material-ui/core/Switch';
import { hasPermission } from '../../../../utils/permissions';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
  marginTop : theme.spacing(2)

  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const UserDetails = props => {
  const { open, onClose,masters, onUpdate, onSendTestPush, usercontent, viewtype, className, ...rest } = props;

  const classes = useStyles();
  const canEditFields = hasPermission('user_edit');
  const canToggleStatus = hasPermission('user_status_toggle');
  const canSave = canEditFields || canToggleStatus;
  const canSendTestPush = hasPermission('user_edit') || hasPermission('user_view');
  const isFieldDisabled = !canEditFields;
  const isStatusDisabled = !canToggleStatus && !canEditFields;

  const initialValues = {
    paymentStatus: '',
    tag: '',
    tags: ['Full-Time'],
    amount: [1, 7],
    projectStatus: 'ended',
    customerName: '',
    customerType: 'freelancer',
    customerEmail: '',
    customerPhone: '',
    customerAge: ''
  };

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...usercontent });

  const handleClear = () => {
    setValues({ ...initialValues });
  };

  React.useEffect(() => {
    
    
    if(usercontent.user_commodity && usercontent.user_commodity.length > 0)
    {
    let user_commodities = []
    let comm =  masters?.commodity
    comm.map((item,index) => {
      if(usercontent.user_commodity.includes(""+item.value))
      {
        user_commodities.push(item)
      }
    })

    setValues(values => ({
      ...values,
      ['user_commodity']: user_commodities
      
    }));
  }

    
  },[usercontent,masters])
  
  const handleoptionchange = type => (event, value) => {
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  const handleinputChange = type => (e) => {
    setValues({
      ...values,
      [type]: e.target.value
    })
  }
  const handlecheckchange  = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.checked == true ? 3 : 4
    })
  }
  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };

  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };

  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
  
   onUpdate && onUpdate(values);
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];
  const usertypemaster = ['Rate giving person', 'Advertisement customer', 'vip person', 'Office  use',"Spam contact","Customer"];

  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
          <Grid container xs={12} spacing={2}>
            <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={isFieldDisabled}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            value={values.name}
                            onChange={handleinputChange('name')}
                           label="Name"
                          />
            </Grid>
            <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Mobile"
                           value={values.mobilenumber}
                           onChange={handleinputChange('mobileNumber')}

                          />
            </Grid>
            <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={isFieldDisabled}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="City"
                           value={values.city}
                           onChange={handleinputChange('city')}
                          />
            </Grid>
            <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={isFieldDisabled}
                            fullWidth
                            autoComplete="off"
                           label="State"
                           value={values.state || ''}
                           onChange={handleinputChange('state')}
                          />
            </Grid>
            <Grid item xs={4}>
            <Autocomplete
                  
                  id="combo-box-demo"
                  options={[
                    {
                      label: "android",
                      value: 'android'
                    },
                    {
                      label: "iOS",
                      value: 'iOS'
                    }
                  ]}
                  margin="dense"
                  disabled={isFieldDisabled}
                
                  fullWidth
                  onChange={handleoptionchange('platform')}
                  value={values.platform}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Platform"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid>
            <Grid item xs={4}>
            <Autocomplete
                  id="combo-box-demo"
                  options={masters.versions}
                  margin="dense"
                  fullWidth
                  getOptionLabel={(option) => option.label}
                  onChange={handleoptionchange('version')}
                  value={values.version}
                  disabled={isFieldDisabled}
                  renderInput={(params) => <TextField {...params} label={"Versions"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
                      
            <Grid item xs={4}>
            <FormControlLabel
            label="Is Active?"
            control={<Switch checked={values.status == 3 ? true : false} onChange={handlecheckchange} name="status" disabled={isStatusDisabled} />}
            
            labelPlacement="start"
            />
       
            </Grid>
            
            {/* <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="language"
                           value={usercontent.preferredLang}
                          />
            </Grid> */}
            <Grid item xs={4}>
            <Autocomplete
                  id="user-type"
                  options={masters?.usertypes || []}
                  margin="dense"
                  fullWidth
                  getOptionLabel={(option) => option && option.name ? option.name : ''}
                  getOptionSelected={(option, value) => option && value && option.id === value.id}
                  onChange={handleoptionchange('user_type')}
                  disabled={isFieldDisabled}
                  value={values.user_type || null}
                  renderInput={(params) => <TextField {...params} label={"Customer Type"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={4}>
           <Autocomplete
                  
                  id="language"
                  key={'language'}
                  name={'language'}
                  options={masters?.languages}
                  margin="dense"
                  fullWidth
                  getOptionLabel={(option) => option.label}
                  onChange={handleoptionchange('language')}
                  value={values.language}
                  disabled={isFieldDisabled}
                  renderInput={(params) => <TextField {...params} label={"language"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={4}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            disabled
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Activation Code"
                           value={usercontent.activation_code}
                          />
            </Grid>
            <Grid item xs={6}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Company Name"
                           value={values.companyname}
                           onChange={handleinputChange('companyname')}
                           disabled={isFieldDisabled}
                          />
            </Grid>
            <Grid item xs={6}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="gstin"
                            name="gstin"
                           label="GSTIN"
                           value={values.gstin || ''}
                           onChange={handleinputChange('gstin')}
                           disabled={isFieldDisabled}
                          />
            </Grid>
           
            <Grid item xs={6}>
            <Autocomplete
                  multiple
                  id="combo-box-demo"
                  options={masters?.commodity}
                  margin="dense"
                  fullWidth
                  disabled={isFieldDisabled}
                  value={values.user_commodity}
                  onChange={handleoptionchange('user_commodity')}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={4} >
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/DD/YYYY  hh:mm a"
                  inputVariant="outlined"
                  margin="dense"
                  id="date-picker-inline"
                  label="Member Since"
                  disabled
                  fullWidth
                  value={usercontent.createdAt}
                  // onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
      </Grid>
            <Grid item xs={4}>
                 <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/DD/YYYY hh:mm a"
                  inputVariant="outlined"
                  margin="dense"
                  id="date-picker-inline"
                  label="Last Login"
                  disabled
                  fullWidth
                  value={usercontent.last_login}

                  // onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
        </Grid>

            <Grid item xs={4}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  disabled
                  fullWidth
                  inputVariant="outlined"
                  format="MM/DD/YYYY"
                  margin="dense"
                  id="date-picker-inline"
                  label="Last Update"
                   value={usercontent.updatedAt}
                  // onChange={handleDateChange}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
      </Grid>
      <Grid item xs={4} >
            <FormControlLabel
            label="Bookmark Push Notification"
            control={<Switch checked={values.is_bookamark} onChange={handlecheckchange} name="is_bookamark" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
            <Grid item xs={4}>
            <FormControlLabel
            label="Live Push Notification"
            control={<Switch checked={values.is_live} onChange={handlecheckchange} name="is_live" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
            <Grid item xs={4}>
            <FormControlLabel
            label="Rate Push Notification"
            control={<Switch checked={values.is_rate} onChange={handlecheckchange} name="is_rate" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
            <Grid item xs={4}>
            <FormControlLabel
            label="News Push Notification"
            control={<Switch checked={values.is_news} onChange={handlecheckchange} name="is_news" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
            <Grid item xs={4}>
            <FormControlLabel
            label="Spot Push Notification"
            control={<Switch checked={values.is_spot} onChange={handlecheckchange} name="is_spot" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
            <Grid item xs={4} justifyContent={"space-between"}>
            <FormControlLabel
            label="Features Push Notification"
            control={<Switch checked={values.is_future} onChange={handlecheckchange} name="is_future" disabled={isFieldDisabled} />}
            
            labelPlacement="start"
            />

                     
            </Grid>
          </Grid>
         
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          {canSendTestPush && onSendTestPush ?
          <Button
            onClick={onSendTestPush}
            variant="outlined"
            style={{ marginRight: 12 }}
          >
            Send Test Push
          </Button> : null}
          {canSave ?
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button> : null}
        </div>
      </form>
      </Paper> 
  );
};

UserDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  onSendTestPush: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object

};

export default UserDetails;
